import { render, staticRenderFns } from "./showIdeaProjectsStand.vue?vue&type=template&id=b885c16c&scoped=true"
import script from "./showIdeaProjectsStand.vue?vue&type=script&lang=js"
export * from "./showIdeaProjectsStand.vue?vue&type=script&lang=js"
import style0 from "./showIdeaProjectsStand.vue?vue&type=style&index=0&id=b885c16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b885c16c",
  null
  
)

export default component.exports